module.exports = __webpack_public_path__ + "img/in-tg.34f1f5dc.svg";